import { CancelationService } from '@/common/services/cancelation/cancelation.service';
import { ReservationDataService } from '@/common/services/details/details.service';
import { CancelationResponseInterface } from '@/core/domain/cancelation/models/cancelation.model';
import { DetailsInterface } from '@/core/domain/details/models/details.model';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'fe-delivery-cancel-parent',
    templateUrl: './delivery-cancel-parent.component.html',
    styleUrls: ['./delivery-cancel-parent.component.scss'],
})
export class DeliveryCancelParentComponent implements OnInit, OnDestroy {
    id: string | null = '';
    reservationDetails: DetailsInterface | null = null;
    cancelationResponse: CancelationResponseInterface | null = null;

    constructor(
        private reservationDataService: ReservationDataService,
        private cancelationService: CancelationService,
        private route: ActivatedRoute,
    ) {}

    ngOnInit(): void {
        this.id = this.route.snapshot.queryParamMap.get('reservationCode');
        this.reservationDataService.getDetails().subscribe((details) => {
            this.reservationDetails = details;
        });
        this.cancelationService.cancelation$.subscribe((response) => {
            this.cancelationResponse = response;
        });
    }

    ngOnDestroy(): void {
        this.cancelationService.clearDetailsCache();
    }

    printPage() {
        window.print();
    }

    getStatusText(): string {
        const status =
            this.reservationDetails?.data?.reservationDetails?.status;

        switch (status) {
            case 'PENDING':
                return 'fe_details_step5_delivery_cancel_parent_top_title_pending';
            case 'CONFIRMED':
                return 'fe_details_step5_delivery_cancel_parent_top_title_confirmed';
            case 'CANCELED':
                return 'fe_details_step5_delivery_cancel_parent_top_title_canceled';
            case 'PAID':
                return 'fe_details_step5_delivery_cancel_parent_top_title_paid';
            case 'REJECTED':
                return 'fe_details_step5_delivery_cancel_parent_top_title_confirmed';
            case 'PRECHECKIN':
                return 'fe_details_step5_delivery_cancel_parent_top_title_precheckin';
            default:
                return 'fe_details_step5_delivery_cancel_parent_top_title_default';
        }
    }
}
